import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SelfAssessmentTemplate2RoutingModule } from './self-assessment-template2-routing.module';
import { SelfAssessmentTemplate2Component } from './self-assessment-template2.component';
import { SelfAssessmentT2DetailsComponent } from './self-assessment-t2-details/self-assessment-t2-details.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AlertModule } from 'ngx-bootstrap/alert';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { DistributedUIModule } from '../distributed-ui-components/distributed-ui.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatChipsModule } from '@angular/material/chips';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { SharedUIModule } from '../shared/shared-ui.module';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { NgxPowerBiModule } from 'ngx-powerbi';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { MatExpansionModule } from '@angular/material/expansion';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { UserService } from 'src/app/core/services/user/user.service';
import { MatSelectModule } from '@angular/material/select';
import { SelfAssessmentTemplate3Module } from '../self-assessment-template3/self-assessment-template3.module';


@NgModule({
  declarations: [
    SelfAssessmentTemplate2Component,
    SelfAssessmentT2DetailsComponent
  ],
  imports: [
    CommonModule,
    SelfAssessmentTemplate2RoutingModule,
    FormsModule,
    ReactiveFormsModule,
    AlertModule.forRoot(),
    //RouterModule.forChild(routes),
    MatDialogModule,
    MatButtonModule,
    MatAutocompleteModule,
    MatInputModule,
    MatDatepickerModule,
    DistributedUIModule,
    MatChipsModule,
    BsDropdownModule,
    SharedUIModule,
    ScrollingModule,
    NgxPowerBiModule,
    AngularEditorModule,
    MatExpansionModule,
    CKEditorModule,
    MatSelectModule,
    SelfAssessmentTemplate3Module
  ],
  exports: [
    SelfAssessmentT2DetailsComponent
  ],
  providers: [
    UserService, // Make sure the UserService is provided here
  ],
})
export class SelfAssessmentTemplate2Module { }
